import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import DispatchProps from "../../../../utils/DispatchProps";
import {IRootState} from "../../../../store";
import * as H from "history";
import ApiService from "../../../ApiService";
import PageTitle from "../../../PageTitle";
import AssignmentAnalyticsOverviewItem from "../../../../models/analytics/monitoring/AssignmentAnalyticsOverviewItem";
import LoadingPage from "../../../LoadingPage";
import Table, {TableColumn} from "../../../Table";

interface AssignmentAnalyticsMonitoringPageProps {
    apiService: ApiService
    history: H.History;
}

interface AssignmentAnalyticsMonitoringPageState {
    overviewItems?: AssignmentAnalyticsOverviewItem[];
}

class AssignmentAnalyticsMonitoringPage extends Component<AssignmentAnalyticsMonitoringPageProps & DispatchProps ,AssignmentAnalyticsMonitoringPageState> {
    static displayName = AssignmentAnalyticsMonitoringPage.name;
    
    private static readonly columns: TableColumn[] = [
        {title: "Tenant Id",propertyPath: "tenantId", flex: 1},
        {title: "School Code",propertyPath: "schoolCode", flex: 1},
        {title: "School Name",propertyPath: "schoolName", flex: 1},
        {title: "License",propertyPath: "license", flex: 1},
        {title: "academicYear",propertyPath: "academicYear", flex: 1},
        {title: "assignmentCount",propertyPath: "assignmentCount", flex: 1},
        {title: "submissionCount",propertyPath: "submissionCount", flex: 1,},
        {title: "lastFetchedAt",propertyPath: "lastFetchedAt", type: "date", flex: 1},
    ];


    constructor(props: AssignmentAnalyticsMonitoringPageProps & DispatchProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidUpdate(prevProps: Readonly<AssignmentAnalyticsMonitoringPageProps & DispatchProps>, prevState: Readonly<AssignmentAnalyticsMonitoringPageState>, snapshot?: any): Promise<void> {

      
    }

    async componentDidMount() {

        const overviewItems = await this.props.apiService.getAssignmentAnalyticsMonitoringOverview(2025);

        this.setState({
            overviewItems
        });
    }
    
    render() {
        
        if(this.state.overviewItems === undefined)
        {
            return <LoadingPage/>;
        }
        
        return (
            <Fragment>
                <PageTitle title={"Assignment Analytics Monitoring"} />
                
                <Table 
                    title={"Overview"}
                    columns={AssignmentAnalyticsMonitoringPage.columns}
                    items={this.state.overviewItems!}
                    rowPropsForItem={(item: AssignmentAnalyticsOverviewItem) => {
                        return {
                            enableRowLink: true,
                            to: `/manage/${item.tenantId}/${item.schoolCode}/assignment-analytics`
                        };
                    }}
                />
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {history: H.History}): AssignmentAnalyticsMonitoringPageProps => {
        return {
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(AssignmentAnalyticsMonitoringPage);